import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../Header";
import SideMenu from "../SideMenu";
import Body from "../Body";
// import Footer from "../Footer/Footer";
import Box from "../Body/Box";
/* import Saleschart from "../Body/Saleschart";
import Chatbox from "../Body/Chatbox";
import Todolist from "../Body/Todolist";
import Quickemail from "../Body/Quickemail";
import Visitors from "../Body/Visitors";
import Salesgraph from "../Body/Salesgraph";
import Calendar from "../Body/Calendar"; */
// import { Link } from "react-router-dom";

// import Spinner from "../common/Spinner";
import { getStats } from "../../actions/authActions";
import Spinner from "../common/Spinner";

class Dashboard extends Component {
  componentDidMount() {
    this.props.getStats();
  }

  onDeleteClick(e) {}

  render() {
    const { stats } = this.props.auth;
    /* const { user } = this.props.auth;
    const { profile, loading } = this.props.profile;

    let dashboardContent;

    if (profile === null || loading) {
      dashboardContent = <Spinner />;
    } else {
      // Check if logged in user has profile data
      if (Object.keys(profile).length > 0) {
        dashboardContent = (
          <div>
            <p className="lead text-muted">
              Welcome <Link to={`/profile/${profile.handle}`}>{user.name}</Link>
            </p>

            <div style={{ marginBottom: "60px" }} />
            <button
              onClick={this.onDeleteClick.bind(this)}
              className="btn btn-danger"
            >
              Delete My Account
            </button>
          </div>
        );
      } else {
        // User is logged in but has no profile
        dashboardContent = (
          <div>
            <p className="lead text-muted">Welcome {user.name}</p>
            <p>You have not yet setup a profile, please add some info</p>
            <Link to="/create-profile" className="btn btn-lg btn-info">
              Create Profile
            </Link>
          </div>
        );
      }
    } */

    return (
      <div className="skin-blue ">
        <div className="wrapper">
          <Header />
          <SideMenu active="dashboard" />
          <Body>
            <section className="content-header">
              <h1>Dashboard</h1>
              <ol className="breadcrumb">
                <li>
                  <a /* href="#" */>
                    <i className="fa fa-dashboard"></i> Home
                  </a>
                </li>
                <li className="active">Dashboard</li>
              </ol>
            </section>
            {Object.keys(stats).length !== 0 ? (
              <section className="content" style={{ minHeight: "660px" }}>
                <Box />

                {/*      <div className="row">
                <section className="col-lg-7 connectedSortable">
                  <Saleschart />
                  <Chatbox />
                  <Todolist />
                  <Quickemail />
                </section>

                <section className="col-lg-5 connectedSortable">
                  <Visitors />
                  <Salesgraph />
                  <Calendar />
                </section>
              </div> */}
              </section>
            ) : (
              <Spinner />
            )}
          </Body>
          {/*  <Footer /> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(mapStateToProps, { getStats })(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js